// import { getWalletScriptUrl } from '../constants/globalConstants'

export const loadScript = (src, position) => {
  if (!position) {
    return
  }
  const script = document.createElement('script')
  // script.setAttribute('async', '')
  // script.setAttribute('id', id)
  script.src = src
  position.appendChild(script)
}

export const addScript = (loaded, scriptSrc) => {
  if (typeof window !== 'undefined' && !loaded.current) {
      loadScript(scriptSrc, document.querySelector('head'))
  }
}

// export const loadScriptUrl = (loaded, paymentGateway) => {
  
// }